module.exports = __webpack_public_path__ + "static/img/bg-pc-web04@w.ae74071.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-archive/bg-pc-web04@w.png
// module id = 4+rU
// module chunks = 0